var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.633 3.39971C11.9009 3.14378 12.2642 3 12.643 3C13.0219 3 13.3852 3.14378 13.6531 3.39971L20.0817 9.54305C20.3495 9.79906 20.5 10.1462 20.5 10.5082C20.5 10.8702 20.3495 11.2174 20.0817 11.4734L13.6531 17.6168C13.3836 17.8655 13.0228 18.0031 12.6482 17.9999C12.2736 17.9968 11.9153 17.8533 11.6504 17.6001C11.3856 17.347 11.2353 17.0046 11.2321 16.6467C11.2288 16.2887 11.3728 15.9439 11.633 15.6864L15.5002 11.8734L1.92859 11.8734C1.54971 11.8734 1.18634 11.7296 0.918425 11.4736C0.650512 11.2176 0.5 10.8703 0.5 10.5082C0.5 10.1462 0.650512 9.79893 0.918425 9.54291C1.18634 9.28689 1.54971 9.14305 1.92859 9.14305L15.5002 9.14305L11.633 5.33008C11.3652 5.07407 11.2148 4.7269 11.2148 4.3649C11.2148 4.0029 11.3652 3.65572 11.633 3.39971Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconNext);
export default __webpack_public_path__ + "static/media/buttonIconNext.22b39e771a4802f8dc1ea2c7045b118a.svg";
export { ForwardRef as ReactComponent };